import {AfterContentInit, Component, ContentChildren, EventEmitter, HostBinding, Input, Output, QueryList} from '@angular/core';
import {isNullOrUndefined} from 'util';
import {FormWizardPaneComponent} from '../form-wizard-pane/form-wizard-pane.component';

const componentBaseName = 'form-wizard';
const selectorName = 'cat-' + componentBaseName;
const defaultClassNames = [selectorName].join(' ');
const StepOffsets = {
  reset: 1,
  stepRange: 1,
  first: 0,
};

interface PaneConfig {
  isActive: boolean;
  isDirty: boolean;
  isValid: boolean;
}

@Component({
  selector: 'cat-form-wizard',
  templateUrl: './form-wizard.component.html',
  styleUrls: ['./form-wizard.component.scss'],
})
export class FormWizardComponent implements AfterContentInit {
  @HostBinding('class') classNames = defaultClassNames;
  @ContentChildren(FormWizardPaneComponent) panes: QueryList<FormWizardPaneComponent>;
  @Input() title: string;
  @Input() isCompletedSuccessfully: boolean;
  @Input() resetAfterComplete = false;
  @Output() resetForm = new EventEmitter();

  @Input()
  set labelButtonComplete(value: string) {
    if (!isNullOrUndefined(value)) {
      this.labels.buttons.complete = value;
    }
  }

  get labelButtonComplete(): string {
    return this.labels.buttons.complete;
  }

  wizardSteps: FormWizardPaneComponent[] = [];
  currentStep: FormWizardPaneComponent;
  currentStepIndex: number;

  labels = {
    buttons: {
      complete: 'Complete',
      resetAfterComplete: 'Create another one',
    },
  };

  private initialPaneConfig = new Map<number, PaneConfig>();

  private _isCompleted = false;

  constructor() {
  }

  private setCurrentStepByIndex(stepIndex) {
    this.currentStep = this.wizardSteps[stepIndex];
    this.currentStep.isActive = true;
    this.currentStepIndex = stepIndex;
  }

  ngAfterContentInit() {
    this.panes.forEach((paneItem: FormWizardPaneComponent, index) => {
      this.initialPaneConfig.set(index, {isActive: paneItem.isActive, isDirty: paneItem.isDirty, isValid: paneItem.isValid});
      this.wizardSteps.push(paneItem);
    });
    this.setCurrentStepByIndex(StepOffsets.first);
  }

  isCompleted() {
    return this._isCompleted && this.isCompletedSuccessfully;
  }

  doResetAfterComplete() {
    return this.resetAfterComplete && this.isCompleted();
  }

  hasPrevious() {
    return this.currentStepIndex > StepOffsets.first;
  }

  hasNext() {
    return (this.currentStepIndex + StepOffsets.stepRange) < this.wizardSteps.length;
  }

  gotoPrevious() {
    if (this.hasPrevious()) {
      this._isCompleted = false;
      this.currentStep.isActive = false;
      this.currentStep.previous.emit();
      this.setCurrentStepByIndex(this.currentStepIndex - StepOffsets.stepRange);
    }
  }

  gotoNext() {
    if (this.hasNext()) {
      this.currentStep.isActive = false;
      this.currentStep.next.emit();
      this.setCurrentStepByIndex(this.currentStepIndex + StepOffsets.stepRange);
    }
  }

  complete() {
    this.currentStep.completed.emit();
    this._isCompleted = true;
  }

  doReset() {
    this.resetForm.emit();
    this._isCompleted = false;
    this.wizardSteps.forEach((component, index) => {
      const paneConfig = this.initialPaneConfig.get(index);
      component.isActive = false;
      component.isValid = paneConfig.isValid;
      component.isDirty = paneConfig.isDirty;
      component.previous.emit();
    });
    this.isCompletedSuccessfully = false;
    this.setCurrentStepByIndex(StepOffsets.reset);

  }

  isNavigateToStepDisabled(step) {
    return !step.isDirty || !step.isValid;
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/ui-form/components/form-wizard/form-wizard.component.ts